import { render, staticRenderFns } from "./unionOrder.vue?vue&type=template&id=4cd029f8&scoped=true"
import script from "./unionOrder.vue?vue&type=script&lang=js"
export * from "./unionOrder.vue?vue&type=script&lang=js"
import style0 from "./unionOrder.vue?vue&type=style&index=0&id=4cd029f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd029f8",
  null
  
)

export default component.exports